import Particles from "react-tsparticles";
import particlesConfig from "./config/particles.config";

const ParticlesBackground = () => {
    return (
        <Particles params={particlesConfig}>
            
        </Particles>
    )
}
export default ParticlesBackground


// import Particles from "react-tsparticles";
// import particlesConfig from "./config/particles.config";
// import { loadFull } from "tsparticles";
// export default function ParticleBackground() {
// 	const particlesInit = async (main) => {
// 		console.log(main);
// 		await loadFull(main);
// 	};
// 	const particlesLoaded = (container) => {
// 		console.log(container);
// 	};
// 	return (
// 		<Particles
// 			params={particlesConfig}
// 			id="tsparticles"
// 			init={particlesInit}
// 			loaded={particlesLoaded}
// 		/>
// 	);
// }
